import { and, has, hasPath, path, prop } from "ramda";
import { IRouteInfo } from "../routes";

import * as R from 'ramda';

export const hasComponent = has("component");
export const propComponent = prop("component");

export const hasRoute = has("route");
export const propRoute = prop("route");

export const hasRouteWithComponent = hasPath(["route","component"])
export const fromRouteWithComponentProps = (props:{route:IRouteInfo}) =>
  ({...propRoute(props),component:path(["route","component"])(props)} as any);

export const hasView = has("view");
export const propView = prop("view");
export const hasRouteAndView= and(hasRoute,hasView);
export const isScreen = and(hasView,hasRoute);
export const fromScreenProps = (props:{route:IRouteInfo,view:any}) =>
  ({...propRoute(props),component:propView(props)});

export const hasRouteAndComponent = and(hasRoute,hasComponent);

export const fromRouteAndComponentProps = (props:{route:IRouteInfo,component:any}) =>
  ({...propRoute(props),component:propComponent(props)});


export const fromRouteAndViewProps = (props:{route:IRouteInfo,view:any}) =>
  ({...propRoute(props),component:propView(props)});


// Assuming RoleType is defined somewhere, for example:
type RoleType = 'admin' | 'user' | 'guest';

// Define the IRootieRoute interface with generic parameter
export interface IRootieRoute<TRouteId = string> {
    id: TRouteId;
    label?: string;
    to: string;
    roles?: RoleType[];
    protected?: boolean;
}

// Function to check if an object is an instance of IRootieRoute
// Assuming TRouteId will be used with proper type elsewhere, here we treat it as any for simplicity
const isRootieRoute = <TRouteId = any>(obj: any): obj is IRootieRoute<TRouteId> => {
  return R.allPass([
      R.has('id'),  // Checks if id exists
      R.propSatisfies(R.is(String), 'to'),  // Ensures 'to' is a string
      R.propSatisfies(R.either(R.isNil, R.is(String)), 'label'),  // 'label' must be either undefined or a string
      R.propSatisfies(R.either(R.isNil, R.all(R.includes(R.__, ['admin', 'user', 'guest']))), 'roles'),  // 'roles' must be an array of RoleType or undefined
      R.propSatisfies(R.either(R.isNil, R.is(Boolean)), 'protected')  // 'protected' must be either undefined or a boolean
  ])(obj);
};
